// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Domino-Core SDK
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, BaseAPI } from './base';
export var PackageStatusStageEnum = {
    Pending: 'pending',
    Processing: 'processing',
    Completed: 'completed',
    Failed: 'failed',
    DeletePending: 'delete_pending',
    DeleteProcessing: 'delete_processing',
    DeleteFailed: 'delete_failed',
    Deleted: 'deleted'
};
/**
 * BlueprintsApi - axios parameter creator
 * @export
 */
export var BlueprintsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Creates a new blueprint definition.
         * @summary Create Blueprint
         * @param {string} body Body required in the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBlueprint: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'body' is not null or undefined
                            assertParamExists('createBlueprint', 'body', body);
                            localVarPath = "/blueprints";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Authorization required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)
                                // authentication x-api-key required
                            ];
                        case 1:
                            // authentication Authorization required
                            _a.sent();
                            // authentication x-api-key required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 2:
                            // authentication x-api-key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/yaml';
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Deletes a blueprint definition.
         * @summary Delete Blueprint
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBlueprint: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('deleteBlueprint', 'id', id);
                            localVarPath = "/blueprints/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Authorization required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)
                                // authentication x-api-key required
                            ];
                        case 1:
                            // authentication Authorization required
                            _a.sent();
                            // authentication x-api-key required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 2:
                            // authentication x-api-key required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Retrieves a blueprint definition.
         * @summary Get Blueprint
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlueprint: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('getBlueprint', 'id', id);
                            localVarPath = "/blueprints/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Authorization required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)
                                // authentication x-api-key required
                            ];
                        case 1:
                            // authentication Authorization required
                            _a.sent();
                            // authentication x-api-key required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 2:
                            // authentication x-api-key required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Enumerates the list of blueprint definitions.
         * @summary List Blueprints
         * @param {string} [tag] Filter results to only those which have the designated tag.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBlueprints: function (tag, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/blueprints";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Authorization required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)
                                // authentication x-api-key required
                            ];
                        case 1:
                            // authentication Authorization required
                            _a.sent();
                            // authentication x-api-key required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 2:
                            // authentication x-api-key required
                            _a.sent();
                            if (tag !== undefined) {
                                localVarQueryParameter['tag'] = tag;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Modifies an existing blueprint definition.
         * @summary Update Blueprint
         * @param {string} id
         * @param {string} body Body required in the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBlueprint: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('updateBlueprint', 'id', id);
                            // verify required parameter 'body' is not null or undefined
                            assertParamExists('updateBlueprint', 'body', body);
                            localVarPath = "/blueprints/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Authorization required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)
                                // authentication x-api-key required
                            ];
                        case 1:
                            // authentication Authorization required
                            _a.sent();
                            // authentication x-api-key required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 2:
                            // authentication x-api-key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/yaml';
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * BlueprintsApi - functional programming interface
 * @export
 */
export var BlueprintsApiFp = function (configuration) {
    var localVarAxiosParamCreator = BlueprintsApiAxiosParamCreator(configuration);
    return {
        /**
         * Creates a new blueprint definition.
         * @summary Create Blueprint
         * @param {string} body Body required in the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBlueprint: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createBlueprint(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Deletes a blueprint definition.
         * @summary Delete Blueprint
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBlueprint: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteBlueprint(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieves a blueprint definition.
         * @summary Get Blueprint
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlueprint: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getBlueprint(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Enumerates the list of blueprint definitions.
         * @summary List Blueprints
         * @param {string} [tag] Filter results to only those which have the designated tag.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBlueprints: function (tag, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listBlueprints(tag, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Modifies an existing blueprint definition.
         * @summary Update Blueprint
         * @param {string} id
         * @param {string} body Body required in the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBlueprint: function (id, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateBlueprint(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * BlueprintsApi - factory interface
 * @export
 */
export var BlueprintsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = BlueprintsApiFp(configuration);
    return {
        /**
         * Creates a new blueprint definition.
         * @summary Create Blueprint
         * @param {string} body Body required in the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBlueprint: function (body, options) {
            return localVarFp.createBlueprint(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Deletes a blueprint definition.
         * @summary Delete Blueprint
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBlueprint: function (id, options) {
            return localVarFp.deleteBlueprint(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieves a blueprint definition.
         * @summary Get Blueprint
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlueprint: function (id, options) {
            return localVarFp.getBlueprint(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Enumerates the list of blueprint definitions.
         * @summary List Blueprints
         * @param {string} [tag] Filter results to only those which have the designated tag.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBlueprints: function (tag, options) {
            return localVarFp.listBlueprints(tag, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Modifies an existing blueprint definition.
         * @summary Update Blueprint
         * @param {string} id
         * @param {string} body Body required in the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBlueprint: function (id, body, options) {
            return localVarFp.updateBlueprint(id, body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * BlueprintsApi - object-oriented interface
 * @export
 * @class BlueprintsApi
 * @extends {BaseAPI}
 */
var BlueprintsApi = /** @class */ (function (_super) {
    __extends(BlueprintsApi, _super);
    function BlueprintsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Creates a new blueprint definition.
     * @summary Create Blueprint
     * @param {string} body Body required in the request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlueprintsApi
     */
    BlueprintsApi.prototype.createBlueprint = function (body, options) {
        var _this = this;
        return BlueprintsApiFp(this.configuration).createBlueprint(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Deletes a blueprint definition.
     * @summary Delete Blueprint
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlueprintsApi
     */
    BlueprintsApi.prototype.deleteBlueprint = function (id, options) {
        var _this = this;
        return BlueprintsApiFp(this.configuration).deleteBlueprint(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieves a blueprint definition.
     * @summary Get Blueprint
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlueprintsApi
     */
    BlueprintsApi.prototype.getBlueprint = function (id, options) {
        var _this = this;
        return BlueprintsApiFp(this.configuration).getBlueprint(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Enumerates the list of blueprint definitions.
     * @summary List Blueprints
     * @param {string} [tag] Filter results to only those which have the designated tag.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlueprintsApi
     */
    BlueprintsApi.prototype.listBlueprints = function (tag, options) {
        var _this = this;
        return BlueprintsApiFp(this.configuration).listBlueprints(tag, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Modifies an existing blueprint definition.
     * @summary Update Blueprint
     * @param {string} id
     * @param {string} body Body required in the request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlueprintsApi
     */
    BlueprintsApi.prototype.updateBlueprint = function (id, body, options) {
        var _this = this;
        return BlueprintsApiFp(this.configuration).updateBlueprint(id, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return BlueprintsApi;
}(BaseAPI));
export { BlueprintsApi };
/**
 * EventsApi - axios parameter creator
 * @export
 */
export var EventsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Retrieves record for a trigger event.
         * @summary Get Trigger Event
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTriggerStatus: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('getTriggerStatus', 'id', id);
                            localVarPath = "/triggerEvents/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Authorization required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)
                                // authentication x-api-key required
                            ];
                        case 1:
                            // authentication Authorization required
                            _a.sent();
                            // authentication x-api-key required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 2:
                            // authentication x-api-key required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Issues a new query request.
         * @summary Query Event
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        query: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('query', 'id', id);
                            localVarPath = "/runs/{id}/query"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Authorization required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)
                                // authentication x-api-key required
                            ];
                        case 1:
                            // authentication Authorization required
                            _a.sent();
                            // authentication x-api-key required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 2:
                            // authentication x-api-key required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates a new signal event.
         * @summary Signal Event
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signal: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('signal', 'id', id);
                            localVarPath = "/runs/{id}/signal"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Authorization required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)
                                // authentication x-api-key required
                            ];
                        case 1:
                            // authentication Authorization required
                            _a.sent();
                            // authentication x-api-key required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 2:
                            // authentication x-api-key required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates a new trigger event for a specific flow.
         * @summary Trigger Flow
         * @param {string} id
         * @param {TriggerFlowRequest} body Body required in the request
         * @param {string} [callback] Callback URL (for http-based updates), or a RealTime Session token.
         * @param {string} [_debugger] Debug session token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerByFlowId: function (id, body, callback, _debugger, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('triggerByFlowId', 'id', id);
                            // verify required parameter 'body' is not null or undefined
                            assertParamExists('triggerByFlowId', 'body', body);
                            localVarPath = "/flows/{id}/trigger"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Authorization required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)
                                // authentication x-api-key required
                            ];
                        case 1:
                            // authentication Authorization required
                            _a.sent();
                            // authentication x-api-key required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 2:
                            // authentication x-api-key required
                            _a.sent();
                            if (callback !== undefined) {
                                localVarQueryParameter['callback'] = callback;
                            }
                            if (_debugger !== undefined) {
                                localVarQueryParameter['debugger'] = _debugger;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * EventsApi - functional programming interface
 * @export
 */
export var EventsApiFp = function (configuration) {
    var localVarAxiosParamCreator = EventsApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieves record for a trigger event.
         * @summary Get Trigger Event
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTriggerStatus: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getTriggerStatus(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Issues a new query request.
         * @summary Query Event
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        query: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.query(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates a new signal event.
         * @summary Signal Event
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signal: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.signal(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates a new trigger event for a specific flow.
         * @summary Trigger Flow
         * @param {string} id
         * @param {TriggerFlowRequest} body Body required in the request
         * @param {string} [callback] Callback URL (for http-based updates), or a RealTime Session token.
         * @param {string} [_debugger] Debug session token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerByFlowId: function (id, body, callback, _debugger, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.triggerByFlowId(id, body, callback, _debugger, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * EventsApi - factory interface
 * @export
 */
export var EventsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = EventsApiFp(configuration);
    return {
        /**
         * Retrieves record for a trigger event.
         * @summary Get Trigger Event
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTriggerStatus: function (id, options) {
            return localVarFp.getTriggerStatus(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Issues a new query request.
         * @summary Query Event
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        query: function (id, options) {
            return localVarFp.query(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates a new signal event.
         * @summary Signal Event
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signal: function (id, options) {
            return localVarFp.signal(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates a new trigger event for a specific flow.
         * @summary Trigger Flow
         * @param {string} id
         * @param {TriggerFlowRequest} body Body required in the request
         * @param {string} [callback] Callback URL (for http-based updates), or a RealTime Session token.
         * @param {string} [_debugger] Debug session token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerByFlowId: function (id, body, callback, _debugger, options) {
            return localVarFp.triggerByFlowId(id, body, callback, _debugger, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * EventsApi - object-oriented interface
 * @export
 * @class EventsApi
 * @extends {BaseAPI}
 */
var EventsApi = /** @class */ (function (_super) {
    __extends(EventsApi, _super);
    function EventsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Retrieves record for a trigger event.
     * @summary Get Trigger Event
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    EventsApi.prototype.getTriggerStatus = function (id, options) {
        var _this = this;
        return EventsApiFp(this.configuration).getTriggerStatus(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Issues a new query request.
     * @summary Query Event
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    EventsApi.prototype.query = function (id, options) {
        var _this = this;
        return EventsApiFp(this.configuration).query(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates a new signal event.
     * @summary Signal Event
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    EventsApi.prototype.signal = function (id, options) {
        var _this = this;
        return EventsApiFp(this.configuration).signal(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates a new trigger event for a specific flow.
     * @summary Trigger Flow
     * @param {string} id
     * @param {TriggerFlowRequest} body Body required in the request
     * @param {string} [callback] Callback URL (for http-based updates), or a RealTime Session token.
     * @param {string} [_debugger] Debug session token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    EventsApi.prototype.triggerByFlowId = function (id, body, callback, _debugger, options) {
        var _this = this;
        return EventsApiFp(this.configuration).triggerByFlowId(id, body, callback, _debugger, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return EventsApi;
}(BaseAPI));
export { EventsApi };
/**
 * FlowsApi - axios parameter creator
 * @export
 */
export var FlowsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Creates a new flow definition.
         * @summary Create Flow
         * @param {string} body Body required in the request
         * @param {string} [containerRID] optional ID for container entity (defaults to account)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFlow: function (body, containerRID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'body' is not null or undefined
                            assertParamExists('createFlow', 'body', body);
                            localVarPath = "/flows";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Authorization required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)
                                // authentication x-api-key required
                            ];
                        case 1:
                            // authentication Authorization required
                            _a.sent();
                            // authentication x-api-key required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 2:
                            // authentication x-api-key required
                            _a.sent();
                            if (containerRID !== undefined) {
                                localVarQueryParameter['containerRID'] = containerRID;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/yaml';
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Deletes a flow definition.
         * @summary Delete Flow
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFlow: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('deleteFlow', 'id', id);
                            localVarPath = "/flows/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Authorization required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)
                                // authentication x-api-key required
                            ];
                        case 1:
                            // authentication Authorization required
                            _a.sent();
                            // authentication x-api-key required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 2:
                            // authentication x-api-key required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Disables a existing flow.
         * @summary Disable Flow
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableFlow: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('disableFlow', 'id', id);
                            localVarPath = "/flows/{id}/disable"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Authorization required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)
                                // authentication x-api-key required
                            ];
                        case 1:
                            // authentication Authorization required
                            _a.sent();
                            // authentication x-api-key required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 2:
                            // authentication x-api-key required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Enables a existing flow.
         * @summary Enable Flow
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableFlow: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('enableFlow', 'id', id);
                            localVarPath = "/flows/{id}/enable"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Authorization required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)
                                // authentication x-api-key required
                            ];
                        case 1:
                            // authentication Authorization required
                            _a.sent();
                            // authentication x-api-key required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 2:
                            // authentication x-api-key required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Retrieves a flow definition.
         * @summary Get Flow
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlow: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('getFlow', 'id', id);
                            localVarPath = "/flows/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Authorization required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)
                                // authentication x-api-key required
                            ];
                        case 1:
                            // authentication Authorization required
                            _a.sent();
                            // authentication x-api-key required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 2:
                            // authentication x-api-key required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns a url that can be used to publish trigger event data to start workflow
         * @summary Get trigger event url
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTriggerUrl: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('getTriggerUrl', 'id', id);
                            localVarPath = "/flows/{id}/triggerUrl"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Authorization required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)
                                // authentication x-api-key required
                            ];
                        case 1:
                            // authentication Authorization required
                            _a.sent();
                            // authentication x-api-key required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 2:
                            // authentication x-api-key required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Enumerates the list of flow definitions.
         * @summary List Flows
         * @param {number} [limit] Specifies the number of records to return per page of results.
         * @param {string} [tag] Filter results to only those which have the designated tag.
         * @param {string} [triggerName] Filter results to only those which have the provided trigger name.
         * @param {boolean} [excludeInactive] Exclude inactive flows from results. Default is false.
         * @param {boolean} [paginate] Paginate results. Responses will be of type FlowInfoListWithPagination. Default is false with responses of type FlowInfoList.
         * @param {string} [continuationToken] Continuation token for pagination.
         * @param {string} [name] If provided, flows returned will have names that contain the value provided.
         * @param {string} [containerRID] Filters results to only those contained within the provided value. Defaults to account.
         * @param {boolean} [includeMetadata] If true, returns a high-level overview object of the flow trigger and associated actions. Default is false
         * @param {boolean} [includeHidden] If true, returns flows that are marked as hidden. Default is false.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFlows: function (limit, tag, triggerName, excludeInactive, paginate, continuationToken, name, containerRID, includeMetadata, includeHidden, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/flows";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Authorization required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)
                                // authentication x-api-key required
                            ];
                        case 1:
                            // authentication Authorization required
                            _a.sent();
                            // authentication x-api-key required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 2:
                            // authentication x-api-key required
                            _a.sent();
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (tag !== undefined) {
                                localVarQueryParameter['tag'] = tag;
                            }
                            if (triggerName !== undefined) {
                                localVarQueryParameter['triggerName'] = triggerName;
                            }
                            if (excludeInactive !== undefined) {
                                localVarQueryParameter['excludeInactive'] = excludeInactive;
                            }
                            if (paginate !== undefined) {
                                localVarQueryParameter['paginate'] = paginate;
                            }
                            if (continuationToken !== undefined) {
                                localVarQueryParameter['continuationToken'] = continuationToken;
                            }
                            if (name !== undefined) {
                                localVarQueryParameter['name'] = name;
                            }
                            if (containerRID !== undefined) {
                                localVarQueryParameter['containerRID'] = containerRID;
                            }
                            if (includeMetadata !== undefined) {
                                localVarQueryParameter['includeMetadata'] = includeMetadata;
                            }
                            if (includeHidden !== undefined) {
                                localVarQueryParameter['includeHidden'] = includeHidden;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Modifies an existing flow definition.
         * @summary Update Flow
         * @param {string} id
         * @param {string} body Body required in the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFlow: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('updateFlow', 'id', id);
                            // verify required parameter 'body' is not null or undefined
                            assertParamExists('updateFlow', 'body', body);
                            localVarPath = "/flows/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Authorization required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)
                                // authentication x-api-key required
                            ];
                        case 1:
                            // authentication Authorization required
                            _a.sent();
                            // authentication x-api-key required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 2:
                            // authentication x-api-key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/yaml';
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * FlowsApi - functional programming interface
 * @export
 */
export var FlowsApiFp = function (configuration) {
    var localVarAxiosParamCreator = FlowsApiAxiosParamCreator(configuration);
    return {
        /**
         * Creates a new flow definition.
         * @summary Create Flow
         * @param {string} body Body required in the request
         * @param {string} [containerRID] optional ID for container entity (defaults to account)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFlow: function (body, containerRID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createFlow(body, containerRID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Deletes a flow definition.
         * @summary Delete Flow
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFlow: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteFlow(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Disables a existing flow.
         * @summary Disable Flow
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableFlow: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.disableFlow(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Enables a existing flow.
         * @summary Enable Flow
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableFlow: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.enableFlow(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieves a flow definition.
         * @summary Get Flow
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlow: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFlow(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns a url that can be used to publish trigger event data to start workflow
         * @summary Get trigger event url
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTriggerUrl: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getTriggerUrl(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Enumerates the list of flow definitions.
         * @summary List Flows
         * @param {number} [limit] Specifies the number of records to return per page of results.
         * @param {string} [tag] Filter results to only those which have the designated tag.
         * @param {string} [triggerName] Filter results to only those which have the provided trigger name.
         * @param {boolean} [excludeInactive] Exclude inactive flows from results. Default is false.
         * @param {boolean} [paginate] Paginate results. Responses will be of type FlowInfoListWithPagination. Default is false with responses of type FlowInfoList.
         * @param {string} [continuationToken] Continuation token for pagination.
         * @param {string} [name] If provided, flows returned will have names that contain the value provided.
         * @param {string} [containerRID] Filters results to only those contained within the provided value. Defaults to account.
         * @param {boolean} [includeMetadata] If true, returns a high-level overview object of the flow trigger and associated actions. Default is false
         * @param {boolean} [includeHidden] If true, returns flows that are marked as hidden. Default is false.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFlows: function (limit, tag, triggerName, excludeInactive, paginate, continuationToken, name, containerRID, includeMetadata, includeHidden, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listFlows(limit, tag, triggerName, excludeInactive, paginate, continuationToken, name, containerRID, includeMetadata, includeHidden, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Modifies an existing flow definition.
         * @summary Update Flow
         * @param {string} id
         * @param {string} body Body required in the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFlow: function (id, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateFlow(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * FlowsApi - factory interface
 * @export
 */
export var FlowsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = FlowsApiFp(configuration);
    return {
        /**
         * Creates a new flow definition.
         * @summary Create Flow
         * @param {string} body Body required in the request
         * @param {string} [containerRID] optional ID for container entity (defaults to account)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFlow: function (body, containerRID, options) {
            return localVarFp.createFlow(body, containerRID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Deletes a flow definition.
         * @summary Delete Flow
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFlow: function (id, options) {
            return localVarFp.deleteFlow(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Disables a existing flow.
         * @summary Disable Flow
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableFlow: function (id, options) {
            return localVarFp.disableFlow(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Enables a existing flow.
         * @summary Enable Flow
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableFlow: function (id, options) {
            return localVarFp.enableFlow(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieves a flow definition.
         * @summary Get Flow
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlow: function (id, options) {
            return localVarFp.getFlow(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a url that can be used to publish trigger event data to start workflow
         * @summary Get trigger event url
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTriggerUrl: function (id, options) {
            return localVarFp.getTriggerUrl(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Enumerates the list of flow definitions.
         * @summary List Flows
         * @param {number} [limit] Specifies the number of records to return per page of results.
         * @param {string} [tag] Filter results to only those which have the designated tag.
         * @param {string} [triggerName] Filter results to only those which have the provided trigger name.
         * @param {boolean} [excludeInactive] Exclude inactive flows from results. Default is false.
         * @param {boolean} [paginate] Paginate results. Responses will be of type FlowInfoListWithPagination. Default is false with responses of type FlowInfoList.
         * @param {string} [continuationToken] Continuation token for pagination.
         * @param {string} [name] If provided, flows returned will have names that contain the value provided.
         * @param {string} [containerRID] Filters results to only those contained within the provided value. Defaults to account.
         * @param {boolean} [includeMetadata] If true, returns a high-level overview object of the flow trigger and associated actions. Default is false
         * @param {boolean} [includeHidden] If true, returns flows that are marked as hidden. Default is false.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFlows: function (limit, tag, triggerName, excludeInactive, paginate, continuationToken, name, containerRID, includeMetadata, includeHidden, options) {
            return localVarFp.listFlows(limit, tag, triggerName, excludeInactive, paginate, continuationToken, name, containerRID, includeMetadata, includeHidden, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Modifies an existing flow definition.
         * @summary Update Flow
         * @param {string} id
         * @param {string} body Body required in the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFlow: function (id, body, options) {
            return localVarFp.updateFlow(id, body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * FlowsApi - object-oriented interface
 * @export
 * @class FlowsApi
 * @extends {BaseAPI}
 */
var FlowsApi = /** @class */ (function (_super) {
    __extends(FlowsApi, _super);
    function FlowsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Creates a new flow definition.
     * @summary Create Flow
     * @param {string} body Body required in the request
     * @param {string} [containerRID] optional ID for container entity (defaults to account)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.createFlow = function (body, containerRID, options) {
        var _this = this;
        return FlowsApiFp(this.configuration).createFlow(body, containerRID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Deletes a flow definition.
     * @summary Delete Flow
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.deleteFlow = function (id, options) {
        var _this = this;
        return FlowsApiFp(this.configuration).deleteFlow(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Disables a existing flow.
     * @summary Disable Flow
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.disableFlow = function (id, options) {
        var _this = this;
        return FlowsApiFp(this.configuration).disableFlow(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Enables a existing flow.
     * @summary Enable Flow
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.enableFlow = function (id, options) {
        var _this = this;
        return FlowsApiFp(this.configuration).enableFlow(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieves a flow definition.
     * @summary Get Flow
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.getFlow = function (id, options) {
        var _this = this;
        return FlowsApiFp(this.configuration).getFlow(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a url that can be used to publish trigger event data to start workflow
     * @summary Get trigger event url
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.getTriggerUrl = function (id, options) {
        var _this = this;
        return FlowsApiFp(this.configuration).getTriggerUrl(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Enumerates the list of flow definitions.
     * @summary List Flows
     * @param {number} [limit] Specifies the number of records to return per page of results.
     * @param {string} [tag] Filter results to only those which have the designated tag.
     * @param {string} [triggerName] Filter results to only those which have the provided trigger name.
     * @param {boolean} [excludeInactive] Exclude inactive flows from results. Default is false.
     * @param {boolean} [paginate] Paginate results. Responses will be of type FlowInfoListWithPagination. Default is false with responses of type FlowInfoList.
     * @param {string} [continuationToken] Continuation token for pagination.
     * @param {string} [name] If provided, flows returned will have names that contain the value provided.
     * @param {string} [containerRID] Filters results to only those contained within the provided value. Defaults to account.
     * @param {boolean} [includeMetadata] If true, returns a high-level overview object of the flow trigger and associated actions. Default is false
     * @param {boolean} [includeHidden] If true, returns flows that are marked as hidden. Default is false.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.listFlows = function (limit, tag, triggerName, excludeInactive, paginate, continuationToken, name, containerRID, includeMetadata, includeHidden, options) {
        var _this = this;
        return FlowsApiFp(this.configuration).listFlows(limit, tag, triggerName, excludeInactive, paginate, continuationToken, name, containerRID, includeMetadata, includeHidden, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Modifies an existing flow definition.
     * @summary Update Flow
     * @param {string} id
     * @param {string} body Body required in the request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.updateFlow = function (id, body, options) {
        var _this = this;
        return FlowsApiFp(this.configuration).updateFlow(id, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FlowsApi;
}(BaseAPI));
export { FlowsApi };
/**
 * PackagesApi - axios parameter creator
 * @export
 */
export var PackagesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create Package and return signed url for s3
         * @summary Create Package
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPackage: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/packages";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Authorization required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)
                                // authentication x-api-key required
                            ];
                        case 1:
                            // authentication Authorization required
                            _a.sent();
                            // authentication x-api-key required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 2:
                            // authentication x-api-key required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Deletes the specified package.
         * @summary Delete Package
         * @param {string} namespace
         * @param {string} name
         * @param {string} version Delete specific version of the package.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePackage: function (namespace, name, version, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'namespace' is not null or undefined
                            assertParamExists('deletePackage', 'namespace', namespace);
                            // verify required parameter 'name' is not null or undefined
                            assertParamExists('deletePackage', 'name', name);
                            // verify required parameter 'version' is not null or undefined
                            assertParamExists('deletePackage', 'version', version);
                            localVarPath = "/packages/{namespace}/{name}"
                                .replace("{".concat("namespace", "}"), encodeURIComponent(String(namespace)))
                                .replace("{".concat("name", "}"), encodeURIComponent(String(name)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Authorization required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)
                                // authentication x-api-key required
                            ];
                        case 1:
                            // authentication Authorization required
                            _a.sent();
                            // authentication x-api-key required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 2:
                            // authentication x-api-key required
                            _a.sent();
                            if (version !== undefined) {
                                localVarQueryParameter['version'] = version;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Retrieves details for a given package.
         * @summary Get Package
         * @param {string} namespace
         * @param {string} name
         * @param {string} [version] Get package info for specific version
         * @param {boolean} [includeDeleted] Include deleted packages in results.  Default is false.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPackage: function (namespace, name, version, includeDeleted, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'namespace' is not null or undefined
                            assertParamExists('getPackage', 'namespace', namespace);
                            // verify required parameter 'name' is not null or undefined
                            assertParamExists('getPackage', 'name', name);
                            localVarPath = "/packages/{namespace}/{name}"
                                .replace("{".concat("namespace", "}"), encodeURIComponent(String(namespace)))
                                .replace("{".concat("name", "}"), encodeURIComponent(String(name)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Authorization required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)
                                // authentication x-api-key required
                            ];
                        case 1:
                            // authentication Authorization required
                            _a.sent();
                            // authentication x-api-key required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 2:
                            // authentication x-api-key required
                            _a.sent();
                            if (version !== undefined) {
                                localVarQueryParameter['version'] = version;
                            }
                            if (includeDeleted !== undefined) {
                                localVarQueryParameter['includeDeleted'] = includeDeleted;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Lists all packages in namespace (latest versions).
         * @summary Get Packages for namespace
         * @param {string} namespace
         * @param {boolean} [includeDeleted] Include deleted packages in results.  Default is false.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPackages: function (namespace, includeDeleted, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'namespace' is not null or undefined
                            assertParamExists('listPackages', 'namespace', namespace);
                            localVarPath = "/packages/{namespace}"
                                .replace("{".concat("namespace", "}"), encodeURIComponent(String(namespace)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Authorization required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)
                                // authentication x-api-key required
                            ];
                        case 1:
                            // authentication Authorization required
                            _a.sent();
                            // authentication x-api-key required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 2:
                            // authentication x-api-key required
                            _a.sent();
                            if (includeDeleted !== undefined) {
                                localVarQueryParameter['includeDeleted'] = includeDeleted;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * PackagesApi - functional programming interface
 * @export
 */
export var PackagesApiFp = function (configuration) {
    var localVarAxiosParamCreator = PackagesApiAxiosParamCreator(configuration);
    return {
        /**
         * Create Package and return signed url for s3
         * @summary Create Package
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPackage: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createPackage(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Deletes the specified package.
         * @summary Delete Package
         * @param {string} namespace
         * @param {string} name
         * @param {string} version Delete specific version of the package.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePackage: function (namespace, name, version, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deletePackage(namespace, name, version, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieves details for a given package.
         * @summary Get Package
         * @param {string} namespace
         * @param {string} name
         * @param {string} [version] Get package info for specific version
         * @param {boolean} [includeDeleted] Include deleted packages in results.  Default is false.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPackage: function (namespace, name, version, includeDeleted, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPackage(namespace, name, version, includeDeleted, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Lists all packages in namespace (latest versions).
         * @summary Get Packages for namespace
         * @param {string} namespace
         * @param {boolean} [includeDeleted] Include deleted packages in results.  Default is false.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPackages: function (namespace, includeDeleted, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listPackages(namespace, includeDeleted, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * PackagesApi - factory interface
 * @export
 */
export var PackagesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = PackagesApiFp(configuration);
    return {
        /**
         * Create Package and return signed url for s3
         * @summary Create Package
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPackage: function (options) {
            return localVarFp.createPackage(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Deletes the specified package.
         * @summary Delete Package
         * @param {string} namespace
         * @param {string} name
         * @param {string} version Delete specific version of the package.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePackage: function (namespace, name, version, options) {
            return localVarFp.deletePackage(namespace, name, version, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieves details for a given package.
         * @summary Get Package
         * @param {string} namespace
         * @param {string} name
         * @param {string} [version] Get package info for specific version
         * @param {boolean} [includeDeleted] Include deleted packages in results.  Default is false.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPackage: function (namespace, name, version, includeDeleted, options) {
            return localVarFp.getPackage(namespace, name, version, includeDeleted, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Lists all packages in namespace (latest versions).
         * @summary Get Packages for namespace
         * @param {string} namespace
         * @param {boolean} [includeDeleted] Include deleted packages in results.  Default is false.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPackages: function (namespace, includeDeleted, options) {
            return localVarFp.listPackages(namespace, includeDeleted, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * PackagesApi - object-oriented interface
 * @export
 * @class PackagesApi
 * @extends {BaseAPI}
 */
var PackagesApi = /** @class */ (function (_super) {
    __extends(PackagesApi, _super);
    function PackagesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create Package and return signed url for s3
     * @summary Create Package
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackagesApi
     */
    PackagesApi.prototype.createPackage = function (options) {
        var _this = this;
        return PackagesApiFp(this.configuration).createPackage(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Deletes the specified package.
     * @summary Delete Package
     * @param {string} namespace
     * @param {string} name
     * @param {string} version Delete specific version of the package.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackagesApi
     */
    PackagesApi.prototype.deletePackage = function (namespace, name, version, options) {
        var _this = this;
        return PackagesApiFp(this.configuration).deletePackage(namespace, name, version, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieves details for a given package.
     * @summary Get Package
     * @param {string} namespace
     * @param {string} name
     * @param {string} [version] Get package info for specific version
     * @param {boolean} [includeDeleted] Include deleted packages in results.  Default is false.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackagesApi
     */
    PackagesApi.prototype.getPackage = function (namespace, name, version, includeDeleted, options) {
        var _this = this;
        return PackagesApiFp(this.configuration).getPackage(namespace, name, version, includeDeleted, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Lists all packages in namespace (latest versions).
     * @summary Get Packages for namespace
     * @param {string} namespace
     * @param {boolean} [includeDeleted] Include deleted packages in results.  Default is false.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackagesApi
     */
    PackagesApi.prototype.listPackages = function (namespace, includeDeleted, options) {
        var _this = this;
        return PackagesApiFp(this.configuration).listPackages(namespace, includeDeleted, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PackagesApi;
}(BaseAPI));
export { PackagesApi };
/**
 * RealtimeApi - axios parameter creator
 * @export
 */
export var RealtimeApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Returns a session token that can be used to subscribe for realtime updates on run status
         * @summary Start Realtime Session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        realtime: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/realtime";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Authorization required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)
                                // authentication x-api-key required
                            ];
                        case 1:
                            // authentication Authorization required
                            _a.sent();
                            // authentication x-api-key required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 2:
                            // authentication x-api-key required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * RealtimeApi - functional programming interface
 * @export
 */
export var RealtimeApiFp = function (configuration) {
    var localVarAxiosParamCreator = RealtimeApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns a session token that can be used to subscribe for realtime updates on run status
         * @summary Start Realtime Session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        realtime: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.realtime(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * RealtimeApi - factory interface
 * @export
 */
export var RealtimeApiFactory = function (configuration, basePath, axios) {
    var localVarFp = RealtimeApiFp(configuration);
    return {
        /**
         * Returns a session token that can be used to subscribe for realtime updates on run status
         * @summary Start Realtime Session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        realtime: function (options) {
            return localVarFp.realtime(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * RealtimeApi - object-oriented interface
 * @export
 * @class RealtimeApi
 * @extends {BaseAPI}
 */
var RealtimeApi = /** @class */ (function (_super) {
    __extends(RealtimeApi, _super);
    function RealtimeApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns a session token that can be used to subscribe for realtime updates on run status
     * @summary Start Realtime Session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RealtimeApi
     */
    RealtimeApi.prototype.realtime = function (options) {
        var _this = this;
        return RealtimeApiFp(this.configuration).realtime(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return RealtimeApi;
}(BaseAPI));
export { RealtimeApi };
/**
 * ResourceEventsApi - axios parameter creator
 * @export
 */
export var ResourceEventsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Retrieves available schemas and their attributes. Filter by RID using query param `?rid={rid}`.
         * @summary Get Resource Event Schemas by RID
         * @param {string} rid RID required to filter results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourceEventSchemas: function (rid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rid' is not null or undefined
                            assertParamExists('getResourceEventSchemas', 'rid', rid);
                            localVarPath = "/resourceEvents/triggers";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Authorization required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)
                                // authentication x-api-key required
                            ];
                        case 1:
                            // authentication Authorization required
                            _a.sent();
                            // authentication x-api-key required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 2:
                            // authentication x-api-key required
                            _a.sent();
                            if (rid !== undefined) {
                                localVarQueryParameter['rid'] = rid;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * ResourceEventsApi - functional programming interface
 * @export
 */
export var ResourceEventsApiFp = function (configuration) {
    var localVarAxiosParamCreator = ResourceEventsApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieves available schemas and their attributes. Filter by RID using query param `?rid={rid}`.
         * @summary Get Resource Event Schemas by RID
         * @param {string} rid RID required to filter results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourceEventSchemas: function (rid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getResourceEventSchemas(rid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * ResourceEventsApi - factory interface
 * @export
 */
export var ResourceEventsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = ResourceEventsApiFp(configuration);
    return {
        /**
         * Retrieves available schemas and their attributes. Filter by RID using query param `?rid={rid}`.
         * @summary Get Resource Event Schemas by RID
         * @param {string} rid RID required to filter results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourceEventSchemas: function (rid, options) {
            return localVarFp.getResourceEventSchemas(rid, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * ResourceEventsApi - object-oriented interface
 * @export
 * @class ResourceEventsApi
 * @extends {BaseAPI}
 */
var ResourceEventsApi = /** @class */ (function (_super) {
    __extends(ResourceEventsApi, _super);
    function ResourceEventsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Retrieves available schemas and their attributes. Filter by RID using query param `?rid={rid}`.
     * @summary Get Resource Event Schemas by RID
     * @param {string} rid RID required to filter results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourceEventsApi
     */
    ResourceEventsApi.prototype.getResourceEventSchemas = function (rid, options) {
        var _this = this;
        return ResourceEventsApiFp(this.configuration).getResourceEventSchemas(rid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ResourceEventsApi;
}(BaseAPI));
export { ResourceEventsApi };
/**
 * ResourcesApi - axios parameter creator
 * @export
 */
export var ResourcesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Execute get or list method of user defined resource
         * @summary Execute resource method
         * @param {string} namespace
         * @param {string} _package
         * @param {string} name
         * @param {ExecuteResourceMethodRequest} body Body required in the request
         * @param {string} [version] Execute method of specific version of resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeResourceMethod: function (namespace, _package, name, body, version, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'namespace' is not null or undefined
                            assertParamExists('executeResourceMethod', 'namespace', namespace);
                            // verify required parameter '_package' is not null or undefined
                            assertParamExists('executeResourceMethod', '_package', _package);
                            // verify required parameter 'name' is not null or undefined
                            assertParamExists('executeResourceMethod', 'name', name);
                            // verify required parameter 'body' is not null or undefined
                            assertParamExists('executeResourceMethod', 'body', body);
                            localVarPath = "/resources/{namespace}/{package}/{name}/execute"
                                .replace("{".concat("namespace", "}"), encodeURIComponent(String(namespace)))
                                .replace("{".concat("package", "}"), encodeURIComponent(String(_package)))
                                .replace("{".concat("name", "}"), encodeURIComponent(String(name)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Authorization required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)
                                // authentication x-api-key required
                            ];
                        case 1:
                            // authentication Authorization required
                            _a.sent();
                            // authentication x-api-key required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 2:
                            // authentication x-api-key required
                            _a.sent();
                            if (version !== undefined) {
                                localVarQueryParameter['version'] = version;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Retrieves a resource definition.
         * @summary Get Resource
         * @param {string} namespace
         * @param {string} _package
         * @param {string} name
         * @param {string} [version] Get a specific version of the resource.
         * @param {boolean} [includeDeleted] Include deleted resources in results.  Default is false.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResource: function (namespace, _package, name, version, includeDeleted, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'namespace' is not null or undefined
                            assertParamExists('getResource', 'namespace', namespace);
                            // verify required parameter '_package' is not null or undefined
                            assertParamExists('getResource', '_package', _package);
                            // verify required parameter 'name' is not null or undefined
                            assertParamExists('getResource', 'name', name);
                            localVarPath = "/resources/{namespace}/{package}/{name}"
                                .replace("{".concat("namespace", "}"), encodeURIComponent(String(namespace)))
                                .replace("{".concat("package", "}"), encodeURIComponent(String(_package)))
                                .replace("{".concat("name", "}"), encodeURIComponent(String(name)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Authorization required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)
                                // authentication x-api-key required
                            ];
                        case 1:
                            // authentication Authorization required
                            _a.sent();
                            // authentication x-api-key required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 2:
                            // authentication x-api-key required
                            _a.sent();
                            if (version !== undefined) {
                                localVarQueryParameter['version'] = version;
                            }
                            if (includeDeleted !== undefined) {
                                localVarQueryParameter['includeDeleted'] = includeDeleted;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Enumerates the list of resources (latest versions).
         * @summary List Resources
         * @param {string} type Filter resources by type
         * @param {string} [category] Filter actions by category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResources: function (type, category, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'type' is not null or undefined
                            assertParamExists('listResources', 'type', type);
                            localVarPath = "/resources";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Authorization required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)
                                // authentication x-api-key required
                            ];
                        case 1:
                            // authentication Authorization required
                            _a.sent();
                            // authentication x-api-key required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 2:
                            // authentication x-api-key required
                            _a.sent();
                            if (type !== undefined) {
                                localVarQueryParameter['type'] = type;
                            }
                            if (category !== undefined) {
                                localVarQueryParameter['category'] = category;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Retrieves all resources in namespace (latest versions).
         * @summary List resources for namespace
         * @param {string} namespace
         * @param {string} type Filter resources by type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResourcesByNamespace: function (namespace, type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'namespace' is not null or undefined
                            assertParamExists('listResourcesByNamespace', 'namespace', namespace);
                            // verify required parameter 'type' is not null or undefined
                            assertParamExists('listResourcesByNamespace', 'type', type);
                            localVarPath = "/resources/{namespace}"
                                .replace("{".concat("namespace", "}"), encodeURIComponent(String(namespace)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Authorization required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)
                                // authentication x-api-key required
                            ];
                        case 1:
                            // authentication Authorization required
                            _a.sent();
                            // authentication x-api-key required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 2:
                            // authentication x-api-key required
                            _a.sent();
                            if (type !== undefined) {
                                localVarQueryParameter['type'] = type;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Retrieves all resources in package (latest versions).
         * @summary List resources in package
         * @param {string} namespace
         * @param {string} _package
         * @param {string} type Filter resources by type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResourcesByPackage: function (namespace, _package, type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'namespace' is not null or undefined
                            assertParamExists('listResourcesByPackage', 'namespace', namespace);
                            // verify required parameter '_package' is not null or undefined
                            assertParamExists('listResourcesByPackage', '_package', _package);
                            // verify required parameter 'type' is not null or undefined
                            assertParamExists('listResourcesByPackage', 'type', type);
                            localVarPath = "/resources/{namespace}/{package}"
                                .replace("{".concat("namespace", "}"), encodeURIComponent(String(namespace)))
                                .replace("{".concat("package", "}"), encodeURIComponent(String(_package)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Authorization required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)
                                // authentication x-api-key required
                            ];
                        case 1:
                            // authentication Authorization required
                            _a.sent();
                            // authentication x-api-key required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 2:
                            // authentication x-api-key required
                            _a.sent();
                            if (type !== undefined) {
                                localVarQueryParameter['type'] = type;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * ResourcesApi - functional programming interface
 * @export
 */
export var ResourcesApiFp = function (configuration) {
    var localVarAxiosParamCreator = ResourcesApiAxiosParamCreator(configuration);
    return {
        /**
         * Execute get or list method of user defined resource
         * @summary Execute resource method
         * @param {string} namespace
         * @param {string} _package
         * @param {string} name
         * @param {ExecuteResourceMethodRequest} body Body required in the request
         * @param {string} [version] Execute method of specific version of resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeResourceMethod: function (namespace, _package, name, body, version, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.executeResourceMethod(namespace, _package, name, body, version, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieves a resource definition.
         * @summary Get Resource
         * @param {string} namespace
         * @param {string} _package
         * @param {string} name
         * @param {string} [version] Get a specific version of the resource.
         * @param {boolean} [includeDeleted] Include deleted resources in results.  Default is false.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResource: function (namespace, _package, name, version, includeDeleted, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getResource(namespace, _package, name, version, includeDeleted, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Enumerates the list of resources (latest versions).
         * @summary List Resources
         * @param {string} type Filter resources by type
         * @param {string} [category] Filter actions by category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResources: function (type, category, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listResources(type, category, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieves all resources in namespace (latest versions).
         * @summary List resources for namespace
         * @param {string} namespace
         * @param {string} type Filter resources by type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResourcesByNamespace: function (namespace, type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listResourcesByNamespace(namespace, type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieves all resources in package (latest versions).
         * @summary List resources in package
         * @param {string} namespace
         * @param {string} _package
         * @param {string} type Filter resources by type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResourcesByPackage: function (namespace, _package, type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listResourcesByPackage(namespace, _package, type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * ResourcesApi - factory interface
 * @export
 */
export var ResourcesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = ResourcesApiFp(configuration);
    return {
        /**
         * Execute get or list method of user defined resource
         * @summary Execute resource method
         * @param {string} namespace
         * @param {string} _package
         * @param {string} name
         * @param {ExecuteResourceMethodRequest} body Body required in the request
         * @param {string} [version] Execute method of specific version of resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeResourceMethod: function (namespace, _package, name, body, version, options) {
            return localVarFp.executeResourceMethod(namespace, _package, name, body, version, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieves a resource definition.
         * @summary Get Resource
         * @param {string} namespace
         * @param {string} _package
         * @param {string} name
         * @param {string} [version] Get a specific version of the resource.
         * @param {boolean} [includeDeleted] Include deleted resources in results.  Default is false.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResource: function (namespace, _package, name, version, includeDeleted, options) {
            return localVarFp.getResource(namespace, _package, name, version, includeDeleted, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Enumerates the list of resources (latest versions).
         * @summary List Resources
         * @param {string} type Filter resources by type
         * @param {string} [category] Filter actions by category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResources: function (type, category, options) {
            return localVarFp.listResources(type, category, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieves all resources in namespace (latest versions).
         * @summary List resources for namespace
         * @param {string} namespace
         * @param {string} type Filter resources by type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResourcesByNamespace: function (namespace, type, options) {
            return localVarFp.listResourcesByNamespace(namespace, type, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieves all resources in package (latest versions).
         * @summary List resources in package
         * @param {string} namespace
         * @param {string} _package
         * @param {string} type Filter resources by type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResourcesByPackage: function (namespace, _package, type, options) {
            return localVarFp.listResourcesByPackage(namespace, _package, type, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * ResourcesApi - object-oriented interface
 * @export
 * @class ResourcesApi
 * @extends {BaseAPI}
 */
var ResourcesApi = /** @class */ (function (_super) {
    __extends(ResourcesApi, _super);
    function ResourcesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Execute get or list method of user defined resource
     * @summary Execute resource method
     * @param {string} namespace
     * @param {string} _package
     * @param {string} name
     * @param {ExecuteResourceMethodRequest} body Body required in the request
     * @param {string} [version] Execute method of specific version of resource.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourcesApi
     */
    ResourcesApi.prototype.executeResourceMethod = function (namespace, _package, name, body, version, options) {
        var _this = this;
        return ResourcesApiFp(this.configuration).executeResourceMethod(namespace, _package, name, body, version, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieves a resource definition.
     * @summary Get Resource
     * @param {string} namespace
     * @param {string} _package
     * @param {string} name
     * @param {string} [version] Get a specific version of the resource.
     * @param {boolean} [includeDeleted] Include deleted resources in results.  Default is false.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourcesApi
     */
    ResourcesApi.prototype.getResource = function (namespace, _package, name, version, includeDeleted, options) {
        var _this = this;
        return ResourcesApiFp(this.configuration).getResource(namespace, _package, name, version, includeDeleted, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Enumerates the list of resources (latest versions).
     * @summary List Resources
     * @param {string} type Filter resources by type
     * @param {string} [category] Filter actions by category
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourcesApi
     */
    ResourcesApi.prototype.listResources = function (type, category, options) {
        var _this = this;
        return ResourcesApiFp(this.configuration).listResources(type, category, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieves all resources in namespace (latest versions).
     * @summary List resources for namespace
     * @param {string} namespace
     * @param {string} type Filter resources by type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourcesApi
     */
    ResourcesApi.prototype.listResourcesByNamespace = function (namespace, type, options) {
        var _this = this;
        return ResourcesApiFp(this.configuration).listResourcesByNamespace(namespace, type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieves all resources in package (latest versions).
     * @summary List resources in package
     * @param {string} namespace
     * @param {string} _package
     * @param {string} type Filter resources by type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourcesApi
     */
    ResourcesApi.prototype.listResourcesByPackage = function (namespace, _package, type, options) {
        var _this = this;
        return ResourcesApiFp(this.configuration).listResourcesByPackage(namespace, _package, type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ResourcesApi;
}(BaseAPI));
export { ResourcesApi };
/**
 * RunsApi - axios parameter creator
 * @export
 */
export var RunsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Requests the cancellation of a run instance.
         * @summary Cancel Run
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelRunById: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('cancelRunById', 'id', id);
                            localVarPath = "/runs/{id}/cancel"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Authorization required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)
                                // authentication x-api-key required
                            ];
                        case 1:
                            // authentication Authorization required
                            _a.sent();
                            // authentication x-api-key required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 2:
                            // authentication x-api-key required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Retrieves a run instance.
         * @summary Get Run
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRun: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('getRun', 'id', id);
                            localVarPath = "/runs/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Authorization required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)
                                // authentication x-api-key required
                            ];
                        case 1:
                            // authentication Authorization required
                            _a.sent();
                            // authentication x-api-key required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 2:
                            // authentication x-api-key required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Retrieves logs for the run.
         * @summary Get Run Logs
         * @param {string} id
         * @param {number} [limit] Limit result to N log entries.
         * @param {string} [nextToken] The nextToken provided by the previous response to continue pagination.
         * @param {string} [startTime] Start time in milliseconds since UNIX epoch. Default is now - 30 days.
         * @param {string} [endTime] End date in milliseconds since UNIX epoch. Default is now.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRunLogs: function (id, limit, nextToken, startTime, endTime, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('getRunLogs', 'id', id);
                            localVarPath = "/runs/{id}/logs"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Authorization required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)
                                // authentication x-api-key required
                            ];
                        case 1:
                            // authentication Authorization required
                            _a.sent();
                            // authentication x-api-key required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 2:
                            // authentication x-api-key required
                            _a.sent();
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (nextToken !== undefined) {
                                localVarQueryParameter['nextToken'] = nextToken;
                            }
                            if (startTime !== undefined) {
                                localVarQueryParameter['startTime'] = startTime;
                            }
                            if (endTime !== undefined) {
                                localVarQueryParameter['endTime'] = endTime;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Enumerates the list of runs.
         * @summary List Runs
         * @param {number} [limit] Specifies the number of records to return per page of results. Defaults to 100.
         * @param {string} [flow] Filter results by flow id.
         * @param {string} [containerRID] Filter results by container. Default is the ShareFile account of the caller if not supplied.
         * @param {boolean} [paginate] Paginate results. Responses will be of type RunInfoListWithPagination. Default is false with responses of type RunInfoList.
         * @param {string} [continuationToken] Continuation token for pagination.
         * @param {string} [name] If provided, runs returned will have names that contain the value provided.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRuns: function (limit, flow, containerRID, paginate, continuationToken, name, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/runs";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Authorization required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)
                                // authentication x-api-key required
                            ];
                        case 1:
                            // authentication Authorization required
                            _a.sent();
                            // authentication x-api-key required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 2:
                            // authentication x-api-key required
                            _a.sent();
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (flow !== undefined) {
                                localVarQueryParameter['flow'] = flow;
                            }
                            if (containerRID !== undefined) {
                                localVarQueryParameter['containerRID'] = containerRID;
                            }
                            if (paginate !== undefined) {
                                localVarQueryParameter['paginate'] = paginate;
                            }
                            if (continuationToken !== undefined) {
                                localVarQueryParameter['continuationToken'] = continuationToken;
                            }
                            if (name !== undefined) {
                                localVarQueryParameter['name'] = name;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Requests the termination of a run instance.
         * @summary Terminate Run
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminateRunById: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('terminateRunById', 'id', id);
                            localVarPath = "/runs/{id}/terminate"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Authorization required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)
                                // authentication x-api-key required
                            ];
                        case 1:
                            // authentication Authorization required
                            _a.sent();
                            // authentication x-api-key required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 2:
                            // authentication x-api-key required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * RunsApi - functional programming interface
 * @export
 */
export var RunsApiFp = function (configuration) {
    var localVarAxiosParamCreator = RunsApiAxiosParamCreator(configuration);
    return {
        /**
         * Requests the cancellation of a run instance.
         * @summary Cancel Run
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelRunById: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.cancelRunById(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieves a run instance.
         * @summary Get Run
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRun: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRun(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieves logs for the run.
         * @summary Get Run Logs
         * @param {string} id
         * @param {number} [limit] Limit result to N log entries.
         * @param {string} [nextToken] The nextToken provided by the previous response to continue pagination.
         * @param {string} [startTime] Start time in milliseconds since UNIX epoch. Default is now - 30 days.
         * @param {string} [endTime] End date in milliseconds since UNIX epoch. Default is now.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRunLogs: function (id, limit, nextToken, startTime, endTime, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRunLogs(id, limit, nextToken, startTime, endTime, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Enumerates the list of runs.
         * @summary List Runs
         * @param {number} [limit] Specifies the number of records to return per page of results. Defaults to 100.
         * @param {string} [flow] Filter results by flow id.
         * @param {string} [containerRID] Filter results by container. Default is the ShareFile account of the caller if not supplied.
         * @param {boolean} [paginate] Paginate results. Responses will be of type RunInfoListWithPagination. Default is false with responses of type RunInfoList.
         * @param {string} [continuationToken] Continuation token for pagination.
         * @param {string} [name] If provided, runs returned will have names that contain the value provided.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRuns: function (limit, flow, containerRID, paginate, continuationToken, name, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listRuns(limit, flow, containerRID, paginate, continuationToken, name, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Requests the termination of a run instance.
         * @summary Terminate Run
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminateRunById: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.terminateRunById(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * RunsApi - factory interface
 * @export
 */
export var RunsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = RunsApiFp(configuration);
    return {
        /**
         * Requests the cancellation of a run instance.
         * @summary Cancel Run
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelRunById: function (id, options) {
            return localVarFp.cancelRunById(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieves a run instance.
         * @summary Get Run
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRun: function (id, options) {
            return localVarFp.getRun(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieves logs for the run.
         * @summary Get Run Logs
         * @param {string} id
         * @param {number} [limit] Limit result to N log entries.
         * @param {string} [nextToken] The nextToken provided by the previous response to continue pagination.
         * @param {string} [startTime] Start time in milliseconds since UNIX epoch. Default is now - 30 days.
         * @param {string} [endTime] End date in milliseconds since UNIX epoch. Default is now.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRunLogs: function (id, limit, nextToken, startTime, endTime, options) {
            return localVarFp.getRunLogs(id, limit, nextToken, startTime, endTime, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Enumerates the list of runs.
         * @summary List Runs
         * @param {number} [limit] Specifies the number of records to return per page of results. Defaults to 100.
         * @param {string} [flow] Filter results by flow id.
         * @param {string} [containerRID] Filter results by container. Default is the ShareFile account of the caller if not supplied.
         * @param {boolean} [paginate] Paginate results. Responses will be of type RunInfoListWithPagination. Default is false with responses of type RunInfoList.
         * @param {string} [continuationToken] Continuation token for pagination.
         * @param {string} [name] If provided, runs returned will have names that contain the value provided.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRuns: function (limit, flow, containerRID, paginate, continuationToken, name, options) {
            return localVarFp.listRuns(limit, flow, containerRID, paginate, continuationToken, name, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Requests the termination of a run instance.
         * @summary Terminate Run
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminateRunById: function (id, options) {
            return localVarFp.terminateRunById(id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * RunsApi - object-oriented interface
 * @export
 * @class RunsApi
 * @extends {BaseAPI}
 */
var RunsApi = /** @class */ (function (_super) {
    __extends(RunsApi, _super);
    function RunsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Requests the cancellation of a run instance.
     * @summary Cancel Run
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunsApi
     */
    RunsApi.prototype.cancelRunById = function (id, options) {
        var _this = this;
        return RunsApiFp(this.configuration).cancelRunById(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieves a run instance.
     * @summary Get Run
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunsApi
     */
    RunsApi.prototype.getRun = function (id, options) {
        var _this = this;
        return RunsApiFp(this.configuration).getRun(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieves logs for the run.
     * @summary Get Run Logs
     * @param {string} id
     * @param {number} [limit] Limit result to N log entries.
     * @param {string} [nextToken] The nextToken provided by the previous response to continue pagination.
     * @param {string} [startTime] Start time in milliseconds since UNIX epoch. Default is now - 30 days.
     * @param {string} [endTime] End date in milliseconds since UNIX epoch. Default is now.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunsApi
     */
    RunsApi.prototype.getRunLogs = function (id, limit, nextToken, startTime, endTime, options) {
        var _this = this;
        return RunsApiFp(this.configuration).getRunLogs(id, limit, nextToken, startTime, endTime, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Enumerates the list of runs.
     * @summary List Runs
     * @param {number} [limit] Specifies the number of records to return per page of results. Defaults to 100.
     * @param {string} [flow] Filter results by flow id.
     * @param {string} [containerRID] Filter results by container. Default is the ShareFile account of the caller if not supplied.
     * @param {boolean} [paginate] Paginate results. Responses will be of type RunInfoListWithPagination. Default is false with responses of type RunInfoList.
     * @param {string} [continuationToken] Continuation token for pagination.
     * @param {string} [name] If provided, runs returned will have names that contain the value provided.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunsApi
     */
    RunsApi.prototype.listRuns = function (limit, flow, containerRID, paginate, continuationToken, name, options) {
        var _this = this;
        return RunsApiFp(this.configuration).listRuns(limit, flow, containerRID, paginate, continuationToken, name, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Requests the termination of a run instance.
     * @summary Terminate Run
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunsApi
     */
    RunsApi.prototype.terminateRunById = function (id, options) {
        var _this = this;
        return RunsApiFp(this.configuration).terminateRunById(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return RunsApi;
}(BaseAPI));
export { RunsApi };
